<template>
	<div :class="bgStatus ? 'top-header black' : 'top-header'">
		<div class="container">
			<a :href="domain" class="logo"></a>
			<ul class="nav-list">
				<li class="nav_li event"><a :href="domain + '/eve/activity'" class="nav">最新活动</a></li>
				<li :class="proActiveStatus ? 'nav_li product active' : 'nav_li product'">
					<a href="javascript:void(0)" class="nav">产品</a>
					<div class="pop-list">
						<dl class="nav1">
							<dt class="ico1">云计算&域名服务</dt>
							<dd>
								<a :href="domain + '/cloud/'">云服务器<em class="hot"></em></a>
								<a :href="domain + '/hosting/'">云虚拟主机</a>
								<a :href="domain + '/domain/'">域名注册</a>
								<a :href="domain + '/sms/'">短信服务</a>
							</dd>
						</dl>
						<dl class="nav13">
						  <dt>新品发布<em class="new"></em></dt>
						  <dd>
							  <a :href="domain + '/mysql'">云数据库 MySQL</a>
							  <a :href="domain + '/redis'">云数据库 Redis</a>
							  <a :href="domain + '/memcached'">云数据库 Memcached</a>
							  <a :href="domain + '/alb'">云负载均衡 ALB</a>
							  <a :href="domain + '/rabbitmq'">云消息队列 MQ</a>
							  <a :href="domain + '/oss'">对象存储 OSS</a>
						  </dd>
						</dl>
						<dl class="nav3">
							<dt class="ico3">IDC服务</dt>
							<dd>
								<a :href="domain + '/server/'">服务器租用</a>
								<a :href="domain + '/collocation/'">服务器托管</a>
								<a :href="domain + '/purchase/'">服务器采购</a>
							</dd>
						</dl>
						<dl class="nav2" style="float: right">
							<dt class="ico2">网站服务</dt>
							<dd>
								 <a :href="domain + '/oem/'">百度智能建站</a>
								 <a :href="domain + '/email/wy/'">企业邮箱</a>
								 <a :href="domain + '/project/cloudhost/'">宝塔面板</a>
							</dd>
						</dl>
						<dl class="nav4">
							<dt class="ico4">安全服务</dt>
							<dd>
								<a :href="domain + '/ssl/'">SSL证书<em class="ssl-text"></em></a>
								<a :href="domain + '/ipv6/'">Ipv6转换<em class="new"></em></a>
								<a :href="domain + '/firewall/'">Web应用防火墙<em class="new"></em></a>
								<a :href="domain + '/strengthen/'">安全加固</a>
								<a :href="domain + '/scan/'">漏洞扫描</a>
								<a :href="domain + '/ddos/'">DDoS高防IP</a>
								<a :href="domain + '/announcement/'">安全通告服务</a>
								<a :href="domain + '/evaluation/'">等保合规安全解决方案</a>
								<a :href="domain + '/permeation/'">渗透测试</a>
								<a :href="domain + '/safety/'">网站安全监测</a>
								<a :href="domain + '/assessment/'">安全评估</a>
								<a :href="domain + '/emergency/'">应急响应</a>
								<a :href="domain + '/code/'">代码审计</a>
								<a :href="domain + '/fortress/'">云堡垒机</a>
								<a :href="domain + '/dataAudit/'">数据库审计</a>
								<a :href="domain + '/logAudit/'">日志审计</a>
								<a :href="domain + '/services/'">安全运维服务</a>
							</dd>
						</dl>
				    </div>
				</li>
				<li class="nav_li" ><a :href="domain + '/mart/'" class="nav">云市场</a></li>
				<li class="nav_li solution">
				    <a href="javascript:void(0)" class="nav">解决方案</a>
					<div class="pop-list">
						<dl class="nav12">
							<dt class="ico1">系统解决方案</dt>
							<dd>
								<a :href="domain + '/solution/community/'">社区电商系统</a>
								<a :href="domain + '/solution/education/'">在线教育系统</a>
								<a :href="domain + '/solution/ecommerce/'">在线电商系统</a>
								<a :href="domain + '/solution/aged/'">智慧养老系统</a>
							</dd>
						</dl>
						<dl class="nav12">
							<dt class="ico1">架构解决方案</dt>
							<dd>
								<a :href="domain + '/solution/eduIes/'">智慧教育架构</a>
								<a :href="domain + '/solution/ecoArc/'">智慧电商架构</a>
								<a :href="domain + '/solution/medical/'">智慧医疗架构</a>
								<a :href="domain + '/solution/trip/'">线上旅游架构</a>
								<a :href="domain + '/solution/logistics/'">智慧物流架构</a>
								<a :href="domain + '/solution/government/'">政务云架构</a>
							</dd>
						</dl>
					</div>
				</li>
				<li class="nav_li security"><a :href="domain + '/security/'" class="nav">服务保障</a></li>
				<li class="nav_li" ><a :href="domain + '/customer/'" class="nav">客户案例</a></li>
				<li class="nav_li" ><a :href="domain + '/cps/'" class="nav">生态合作</a></li>
				<li class="nav_li" ><a :href="domain + '/docs/'" class="nav">帮助中心</a></li>
				<li class="nav_li"><a :href="domain + '/help/aboutus/'" class="nav">关于我们</a></li>
			</ul>
			<div class="nav-right" id="navRight">
				<a :href="domain + '/user/icp/index/'">备案</a>
				<span v-if="$store.state.loginFlag">
					<a :href="domain + '/user/'" class="member">{{ $store.state.userName }}</a>
					<a :href="domain + '/user/'" class="user">控制台</a>
					<a :href="domain + '/index/user/logout.html'" class="exit">退出</a>
				</span>
				<span v-else>
					<a :href="accountDomain + '/login'" class="btn">登录</a>
					<a :href="accountDomain + '/register'" class="btn btn-register">立即注册</a>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref,inject,onMounted} from "vue";
	
	const domain = inject('domain');
	const accountDomain = inject('accountDomain');
	const proActiveStatus = ref(false);
	const props = defineProps({
	  bgStatus: {
	    type: Boolean,
	    default: false,
	  }
	});
	
	if(window.location.href.includes('#/pay')){
		proActiveStatus.value = true
	}else{
		proActiveStatus.value = false
	}
	
	onMounted(() => {
		setTimeout(function() {
		    document.getElementById('navRight').style.opacity = 1;
		}, 450)
	});
	
</script>

<style lang="scss">
	.login-dialog{
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 999;
		background: rgba(0, 0, 0, .3);
		.main{
			width: 520px;
			height: 420px;
			position: absolute;
			left: 50%;
			top: 50%;
			margin: -210px 0 0 -260px;
			background-color: #fff;
			.cloumn {
			    height: 60px;
			    padding: 0 20px 0 40px;
			    line-height: 60px;
			    color: #fff;
			    font-size: 18px;
			    background: #015bfe;
			    overflow: hidden;
				span{
					width: 16px;
					height: 16px;
					float: right;
					margin: 20px 0 0;
					background: url(https://static.landui.com/statics/images/public/ico/float-close.png) no-repeat;
					cursor: pointer;
				}
			}
		}
		.go-reg {
		    margin: 30px 0;
		    overflow: hidden;
			span{color: #015bfe;cursor: pointer;}
			p {
			    float: right;
			    color: #666;
			}
		}
		.other {
		    padding: 8px 85px 0;
		    color: #666666;
		    overflow: hidden;
			p{float: left;}
			.ico{ display: inline-block; width: 19px; height:20px; margin-right:8px; vertical-align: text-top; background: url("https://static.landui.com/statics/images/user/icons.png") no-repeat; cursor:pointer;}
			.qq{ background-position: -160px 0; }
			.weixin{ background-position: -139px 0; }
		}
		.register {
		    margin: 0 85px;
		    border-top: 1px solid #ddd;
		    line-height: 50px;
		    text-align: right;
		    overflow: hidden;
			a,span{
				cursor: pointer;
				color: #015BFE;
			}
			span{
				float: left;
			}
		}
		.check-account{
			height: 196px;
			margin-bottom: 15px;
			overflow-y: auto;
			h4{
				 line-height: 30px; 
				 margin-bottom: 10px;
				 .back{float: right;font-size: 14px;color: #015BFE;cursor: pointer;}
			}
			.li{
				border: 1px solid #dfdfdf;
				margin-bottom: 10px;
				padding: 12px 10px;
				font-size: 12px;
				color: #666;
				position: relative;
				padding-right: 170px;
				padding-left: 35px;
				background: url(../assets/images/radio-normal.png) 10px center no-repeat;
				cursor: pointer;
				overflow: hidden;
				p{color: #333; font-size: 14px; margin-bottom: 2px;}
				.tags{position: absolute;right: 0;top: 8px;}
				.el-tag{margin-right: 10px;}
			}
			.active{
				border-color: #015BFE;
				background: url(../assets/images/radio-checked.png) 10px center #E6EFFF no-repeat;
				p{font-weight: 600;}
			}
		}
		#login_container iframe {
		    height: 280px !important;
			margin-top: 14px;
		}
	}
	.top-header {
	    position: absolute;
	    left: 0;
	    right: 0;
	    top: 0;
	    z-index: 11;
		height:95px;
		min-width: 1280px;
		.container{max-width: 1600px; width: 100%;margin: 0 auto;}
		.logo{ float: left; width: 108px; height: 32px; margin: 31px 30px 0 0;background: url("https://static.landui.com/statics/images/public/logo.png") left center no-repeat;}
		.nav-list{
			float: left;
			li {
			    float: left;
			    position: relative;
				.nav{ display: block; color: #fff; font-size: 16px; line-height:95px; padding: 0 16px;}
			}
			.active .nav {
			    color: #1f93ff;
			}
			.event .nav{padding-right: 0;}
			.security .nav{ padding-left: 0}
			.product .nav{ padding-left:32px;}
			.solution .nav{ padding-right:32px;}
			.pop-list{
				display: none; 
				position: absolute; 
				left:-24px; 
				width: 120px; 
				top:96px; 
				z-index: 11; 
				background: #fff; 
				border-radius: 3px; 
				padding:18px 20px 10px 0;
				a{ display: block; line-height: 30px;color: #666;}
				em {
				    display: inline-block;
				    vertical-align: text-top;
				    width: 31px;
				    height: 15px;
				    margin: 2px 0 0 5px;
				}
				.hot{background: url("https://static.landui.com/statics/images/index/ico/ico4.png") center no-repeat;}
				.new{background: url("https://static.landui.com/statics/images/public/ico/new.png") center no-repeat;}
				.ssl-text{ width: 78px; background: url("https://static.landui.com/statics/images/index/ico/text.png") center no-repeat;}
				dl{
					float: left; 
					width: 160px; 
					margin:0 10px 10px 20px;
					dt{border-bottom: 1px solid #ddd; color: #000; line-height: 35px; padding-left: 24px;}
					dd{ 
						padding: 12px 0 0; 
						overflow: hidden;
						a{float: left; width: 160px; margin-right:30px;}
					}
				}
				.nav1 dt{background: url("https://static.landui.com/statics/images/public/ico/nav1.png") left center no-repeat;}
				.nav2 dt{background: url("https://static.landui.com/statics/images/public/ico/nav2.png") left center no-repeat;}
				.nav3 dt{background: url("https://static.landui.com/statics/images/public/ico/nav3.png") left center no-repeat;}
				.nav4{
					 width: 540px;
					 dt{background: url("https://static.landui.com/statics/images/public/ico/nav4.png") left center no-repeat;}
					 dd{
						 a{float: left; width: 160px; margin-right:30px;}
						 a:nth-child(3n){ margin-right:0;}
					 }
				} 
				.nav13 dt{background: url("https://static.landui.com/statics/images/public/ico/nav13.png") left center no-repeat;}
				.nav12 dt{background: url("https://static.landui.com/statics/images/public/ico/nav12.png") left center no-repeat;}
			}
			.pop-list:before{ content: ""; position: absolute; left: 50%; margin-left: -6px; top: -12px; border:6px solid transparent;border-bottom-color: #fff;}
			.product .pop-list{width: 590px !important; left:-80px; }
			.product .pop-list:before{left: 126px;}
			.solution .pop-list{width: 402px !important;}
			.solution .pop-list:before{left: 72px;}
			li:hover .nav{ color: #1f93ff;}
			li:hover .pop-list{display: block;}
		}
		.nav-right{
			opacity: 0;
			float: right;
			height: 40px; 
			margin:28px 0 0;
			text-align: right;
			a{ display: inline-block; vertical-align: middle; margin-left:12px; line-height: 40px; color: #fff;}
			a:hover{ color:#059fff;}
			.btn{ height: 40px; border: 1px solid rgba(255,255,255,.5); width: 60px; text-align: center;line-height: 38px; color: #fff;}
			.btn:hover{ color: #fff}
			.btn-register{border:1px solid #015bfe; width: 120px; background: #015bfe;color: #fff !important;}
			.btn-register:before{content: ""; width: 14px; margin-right: 5px; display: inline-block; vertical-align: top; height: 38px;background: url("https://static.landui.com/statics/images/public/ico/register.png") right center no-repeat;}
			.member{margin:0 8px 0 16px; max-width: 104px; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
			.member:before{ content:''; display:inline-block; width:14px; height: 18px; vertical-align:middle; margin-right: 5px; background: url("https://static.landui.com/statics/images/public/ico/member.png") center top no-repeat;}
		}
	}
	.black{background: #191c22;}
	@media (max-width: 1620px) {
	    .top-header .container{ width: 95%;}
	}
</style>